import { render, staticRenderFns } from "./CompanyNewsContent.vue?vue&type=template&id=2b9b43aa&scoped=true&"
import script from "./CompanyNewsContent.vue?vue&type=script&lang=js&"
export * from "./CompanyNewsContent.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNewsContent.vue?vue&type=style&index=0&id=2b9b43aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9b43aa",
  null
  
)

export default component.exports